import { useTranslation } from "react-i18next";

import DescriptionListItem from "@/components/Elements/DescriptionListItem";
import MaterialFieldPreview from "@/components/Elements/FieldPreview/MaterialFieldPreview";
import StaticLevelPreview from "@/components/Elements/FieldPreview/StaticLevelPreview";
import TextFieldPreview from "@/components/Elements/FieldPreview/TextFieldPreview";
import { ObservationItem } from "@/components/Observation/Observation.type";
import {
  useGetObservationMaterialInfos,
  useGetObservationComponent,
} from "@/entities/observation";

const ObservationSummarySeverityGrid = ({ observation }) => {
  const { t } = useTranslation("observation");

  const { component, isLoading: isComponentLoading } =
    useGetObservationComponent(observation);

  const {
    material,
    defect,
    isLoading: isMaterialsLoading,
  } = useGetObservationMaterialInfos(observation);

  return (
    <dl className="observation-severity-grid">
      <DescriptionListItem
        id="observation-component"
        label={t("source.component")}
        content={
          <TextFieldPreview
            value={component}
            loading={isComponentLoading}
            ellipsis
          />
        }
      />
      <DescriptionListItem
        id="observation-material"
        label={t("source.material")}
        content={
          <MaterialFieldPreview value={material} loading={isMaterialsLoading} />
        }
      />
      <DescriptionListItem
        id="observation-defect"
        label={t("source.defect")}
        content={
          <MaterialFieldPreview value={defect} loading={isMaterialsLoading} />
        }
      />
      <DescriptionListItem
        id="observation-severity"
        label={t("severity")}
        content={
          <StaticLevelPreview field="severity" level={observation.severity} />
        }
      />
    </dl>
  );
};

ObservationSummarySeverityGrid.propTypes = {
  observation: ObservationItem,
};

export default ObservationSummarySeverityGrid;
